import { formateDate, getWeek, getYear, getMonth } from "./TimeUtil";
export default {

    props: {
        info: {},
        value: {}
    },
    render(h) {
        let info = this.info;
        let content = [];
        //有label的表单组件
        if (info.compType == "barCode" || info.compType == "button") {
            info.label = null;
        }
        if (info.label) {
            let labelStyle = {};
            info.labelWidth && (labelStyle.width = info.labelWidth + "px");
            content.push(h("div", {
                class: ["data_item_label"],
                style: labelStyle
            }, info.label + ":"))
        };
        let value = this.value;
        if (info.compType == "date") {
            let type = info.type;
            if (type == "week") {
                value = getWeek(value);
            } else if (type == "month") {
                value = getMonth(value);
            } else if (type == "year") {
                value = getYear(value);
            } else {
                value = formateDate(value, "YYYY-MM-DD")
            };
            // value = formateDate(value, "YYYY-MM-DD");
        }
        content.push(h("div", {
            class: ["data_item_ctx"]
        }, [
            h("ValueRender", {
                props: {
                    info,
                    value,
                }
            })
        ]))


        return h("div", {
            class: ["data_item"]
        }, content);
    },

}

